import React from "react";
import { Slider, Dialog } from "@alife/next";
import {
  formatNumber,
  handleTagsObj,
  handleCoupon,
  getUrlParms,
  convertBuyerTags,
  getExpParams,
} from "./utils.js";
import jsonp from "@alife/common-jsonp";
import _ from "lodash";
import "./index.scss";

// const loadWWJs = (url) => {
//   const script = document.createElement("script");
//   script.type = "text/javascript";
//   script.async = true;
//   script.src = url;
//   document.head.appendChild(script);
// };

// // 旺旺亮灯
// loadWWJs(`https://g.alicdn.com/aliww/ww-light-cbu/index.js?t=${Date.now()}`);

// ICON
const SHILI_ICON =
  "https://img.alicdn.com/imgextra/i2/O1CN01lmgxTV1MeGl7ScL9e_!!6000000001459-2-tps-156-30.png";
const CHAOGONG_ICON =
  "https://img.alicdn.com/imgextra/i3/O1CN01JogJYk1ZR4LauNmbM_!!6000000003190-2-tps-136-32.png";
const JGL_ICON =
  "https://img.alicdn.com/imgextra/i1/O1CN01YG6VRb1gMfsHRzTDa_!!6000000004128-2-tps-36-32.png";
const VIDEO_ICON =
  "https://img.alicdn.com/imgextra/i3/O1CN01M3FGYZ1jktfWaqg9k_!!6000000004587-2-tps-136-48.png";
const DANCING_GIF =
  "https://img.alicdn.com/imgextra/i1/O1CN01Min8b31DpPsCNleZn_!!6000000000265-1-tps-80-80.gif";

export default function Offer(props) {
  const { data, buyerTags } = props;
  const offer = data || {};
  const buyerIdentity = convertBuyerTags(buyerTags);
  const { showImgSlider, showDancingWW, showVideoIcon } = offer;
  const alitalkidUTF8 = encodeURIComponent(offer.loginId + "" || "");
  const title = offer.subject && offer.subject.replace(/<[/]?font.*?>/g, "");
  const urlParams = getUrlParms();
  const exp = window.pageConfig && window.pageConfig.exp;
  const expParams = getExpParams(exp);
  //   if (offer.imgUrl.indexOf("cbu01.alicdn.com") > -1) {
  //     offer.imgUrl = `${offer.imgUrl.replace(".jpg", ".220x220.jpg")}?_=2020`;
  //   }

  // 标签逻辑处理
  const hasCoupon = offer.marketingTagList.length > 0;
  const promotionTag = hasCoupon && handleCoupon(offer.marketingTagList);
  let {
    isShili,
    isSuperFactory,
    productTag,
    priceTag,
    serviceTags,
    isJglOffer,
    creditTags,
    lowPriceTag,
  } = handleTagsObj(offer.offerTagMap);
  serviceTags = hasCoupon ? serviceTags.slice(0, 2) : serviceTags.slice(0, 3);
  lowPriceTag = lowPriceTag.length && lowPriceTag[0];
  const saleListExp = expParams["qztf"] == "H";

  // 添加打点参数
  let cbu_ad_sessionid = "";
  let cbu_ad_adgroup_id = "";
  let trackInfo = offer.trackInfo;
  if (trackInfo && typeof trackInfo === "string") {
    trackInfo = JSON.parse(trackInfo);
  } else if (!trackInfo) {
    trackInfo = {};
  }
  cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
  cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

  const handleWWClick = (e) => {
    e.stopPropagation();
    props.wwClick && props.wwClick();
  };

  const showLowPriceClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.showLowPriceDialog && props.showLowPriceDialog();
  };

  const renderImage = (img) => {
    if (img.indexOf("cbu01.alicdn.com") > -1 && !/220x220/.test(img)) {
      return `${img
        .replace(".summ", "")
        .replace(".jpg", ".220x220.jpg")}?_=2020`;
    }
    return img.replace(".summ", "");
  };
  const RenderOfferImg = () => {
    const { imgUrlList } = offer;
    if (showImgSlider) {
      return (
        <div className="offer-img">
          <Slider
            arrows={false}
            autoplay
            autoplaySpeed={5000}
            draggable={false}
            dots={false}
            pauseOnHover
          >
            {imgUrlList &&
              imgUrlList.length > 0 &&
              imgUrlList.map((img, idx) => {
                return (
                  <img
                    src={renderImage(img)}
                    className="main-img"
                    alt={title}
                    key={idx}
                  />
                );
              })}
          </Slider>
          {showVideoIcon && <img className="video" src={VIDEO_ICON} />}
        </div>
      );
    }
    return (
      <div className="offer-img">
        <img
          src={offer.imgUrl && renderImage(offer.imgUrl)}
          className="main-img layLoad"
          alt={title}
        />
        {showVideoIcon && <img className="video layLoad" src={VIDEO_ICON} />}
      </div>
    );
  };

  const RenderTitle = () => {
    return (
      <div className="offer-title">
        {/* 商品标 */}
        {productTag}
        <span title={title}>{title}</span>
      </div>
    );
  };

  const RenderDacuIcon = () => {
    if (
      offer.offerPromotionDTO &&
      offer.offerPromotionDTO.pcOfferIcon &&
      expParams.pcDacuIconExp === "B"
    ) {
      return (
        <div className="offer-dacu-icon">
          <img src={offer.offerPromotionDTO.pcOfferIcon} />
        </div>
      );
    } else {
      return "";
    }
  };

  // const RenderOfferTags = () => {
  //   return (
  //     <div className="offer-tags">
  //       {/* 优惠券 */}
  //       {promotionTag}
  //       {/* 服务标 */}
  //       {serviceTags}
  //       {/* 跨境决策因子 */}
  //       {/* cpv */}
  //     </div>
  //   );
  // };

  const RenderPriceInfo = () => {
    // const isJiaGeLiOffer = buyerIdentity.jiaGeLi && isJglOffer && offer.price !== "价格面议";
    const priceNumArr = formatNumber(offer.price, 2);
    const hasDecimal = priceNumArr.length > 1;
    const rebuyRate = (Number(offer.shopRepurchaseRate) * 100).toFixed();
    let soltSpan = null;
    if (
      offer.saleVolume &&
      /^\d+$/.test(offer.saleVolume) &&
      offer.saleVolume > 100
    ) {
      soltSpan = (
        <span className="solt solt-r" key="solt">
          成交{formatNumber(offer.saleVolume, 0).join(".")}件
        </span>
      );
    } else if (
      offer.saleVolume &&
      !/^\d+$/.test(offer.saleVolume) &&
      (offer.saleVolume.includes("00") || offer.saleVolume.includes("万"))
    ) {
      soltSpan = (
        <span className="solt solt-r" key="solt">
          成交{offer.saleVolume}件
        </span>
      );
    } else if (
      rebuyRate !== "0" &&
      !!offer.shopRepurchaseRate &&
      rebuyRate > 30
    ) {
      soltSpan = <span className="solt solt-r">{`回头率${rebuyRate}%`}</span>;
    } else {
      soltSpan = (
        <span className="solt solt-r">
          {_.get(offer, 'zhurong["10003"].normalDpa[0].v')}
        </span>
      );
    }
    return (
      <div className="offer-price">
        {offer.price && (
          <span className="price" key="price">
            <em className="symbol">￥</em>
            <em className="number">{priceNumArr[0]}</em>
            {hasDecimal && <em className="number n-s">.{priceNumArr[1]}</em>}
          </span>
        )}
        {saleListExp && data.offerBangdan && data.offerBangdan.ranking <= 30 ? (
          <span
            className="low-price-select"
            onClick={(e) => showLowPriceClick(e)}
          >
            入选高销量榜单 &gt;
          </span>
        ) : (
          <span>
            {soltSpan}
            {lowPriceTag || promotionTag || priceTag}
          </span>
        )}
        {/* {soltSpan} */}
        {/* 价格标 新人满减 > 一件包邮 */}
        {/* {lowPriceTag || promotionTag || priceTag} */}
      </div>
    );
  };

  const RenderTags = (list) => {
    return list.map((item) => {
      return (
        <span className="tag service" key={item}>
          {item}
        </span>
      );
    });
  };

  const RenderCompanyInfo = () => {
    const tag = [];
    if (isSuperFactory) {
      tag.push(<img className="shop-icon" key="icon1" src={CHAOGONG_ICON} />);
    } else if (isShili) {
      tag.push(<img className="shop-icon h14" key="icon2" src={SHILI_ICON} />);
    }
    // } else {
    //   tag.push(
    //     <span className="name" title={offer.company} key="company-info">
    //       {offer.company}
    //     </span>
    //   );
    // }
    // {/* 优惠券 */}
    // {/* {promotionTag} */}
    // {/* 服务标 */}
    // {/* {serviceTags} */}
    // {/* 跨境决策因子 */}
    // {/* cpv */}
    const tagList = serviceTags.splice(0, tag.length ? 2 : 3);
    return (
      <div className="offer-company">
        {tag}
        <div className="offer-tags">
          {RenderTags(tag.length || tagList.length ? tagList : creditTags)}
        </div>
        <div className="right-info">
          <div className="common-wangwang-tag" onClick={handleWWClick}>
            <span
              className="J_WangWang"
              data-nick={alitalkidUTF8}
              data-encode="true"
              data-icon="static"
              data-from="cnalichn"
              data-display="inline"
            />
          </div>
        </div>
        {showDancingWW && <img className="on-line" src={DANCING_GIF} />}
      </div>
    );
  };

  return (
    <div className="new_ui_offer offer_item">
      <a href={offer.eurl ? offer.eurl : offer.odUrl} target="_blank">
        {RenderOfferImg()}
        {RenderTitle()}
        {RenderPriceInfo()}
        {/* {RenderOfferTags()} */}
        {RenderCompanyInfo()}
        {RenderDacuIcon()}
      </a>
      {urlParams._debugMode_ == 1 && (
        <div title={offer.debugMark} className="debug">
          {offer.debugMark}
        </div>
      )}
    </div>
  );
}
